"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleSwitch = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Tappable = require('react-tappable');
var StyledTappable = (0, _styledComponents["default"])(Tappable)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  height: 20px;\n  .toggle-switch {\n    position: relative;\n    display: inline-block;\n    width: 28px;\n    height: 12px;\n  }\n  .slider {\n    position: absolute;\n    cursor: pointer;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: #888888;\n    -webkit-transition: 0.1s;\n    transition: 0.2s;\n    transition-timing-function: ease-out;\n  }\n  .slider.on {\n    background: #2ecc71;\n  }\n  .slider:before {\n    position: absolute;\n    content: '';\n    height: 16px;\n    width: 16px;\n    left: 0px;\n    bottom: -2px;\n    background-color: white;\n    -webkit-transition: 0.1s;\n    transition: 0.1s;\n    border: 1px solid #888888;\n    box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.15);\n    transition-timing-function: ease-out;\n  }\n  .slider.on:before {\n    border: 1px solid #2ecc71;\n    left: -8px;\n    -webkit-transform: translateX(24px);\n    -ms-transform: translateX(24px);\n    transform: translateX(24px);\n  }\n  .slider.round {\n    border-radius: 34px;\n  }\n  .slider.round:before {\n    border-radius: 50%;\n  }\n"])));

/**
 * Toggle switch component
 */
var ToggleSwitch = exports.ToggleSwitch = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ToggleSwitch, _React$Component);
  var _super = _createSuper(ToggleSwitch);
  function ToggleSwitch(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ToggleSwitch);
    _this = _super.call(this, props);
    _this._handleClick = _this._handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(ToggleSwitch, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        on = _this$props.on,
        className = _this$props.className,
        ddActionName = _this$props.ddActionName,
        dataTestId = _this$props.dataTestId;
      var onString = on ? 'on' : 'off';
      return /*#__PURE__*/_react["default"].createElement(StyledTappable, {
        "data-dd-action-name": ddActionName,
        className: className,
        onTap: this._handleClick,
        "data-testid": dataTestId ? dataTestId : 't-tappable'
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "toggle-switch"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "slider round ".concat(onString),
        title: ddActionName && ddActionName.includes('Toggle Name cards') ? '' : onString
      })));
    }
  }, {
    key: "_handleClick",
    value: function _handleClick(e) {
      this.props.onClick(e);
    }
  }]);
  return ToggleSwitch;
}(_react["default"].Component); // We add className so we can use it with the `styled()` factory: https://styled-components.com/docs/basics#styling-any-component
(0, _defineProperty2["default"])(ToggleSwitch, "defaultProps", {
  on: true
});
ToggleSwitch.propTypes = {
  on: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  className: _propTypes["default"].string,
  dataTestId: _propTypes["default"].string
};